import { render, staticRenderFns } from "./PageBreakElement.vue?vue&type=template&id=4eca2e58&"
import script from "./PageBreakElement.vue?vue&type=script&lang=js&"
export * from "./PageBreakElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports